export default __webpack_public_path__ + "static/media/tucoimbra.600aad93.png";